import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import Flag from '@xingternal/malt-flag';
import { TrackedLink, withTracking } from '../../xing-tracking';
import trackings from '../../trackings';

import styles from './index.css';

const QuicklinksLink = ({ link, intl: { formatMessage } }) => {
  const text = formatMessage({ id: link.title });

  return (
    <div className={styles.item} key={link.title}>
      <TrackedLink
        trackingKey="footer"
        href={link.href}
        className={styles.link}
      >
        {text}
      </TrackedLink>
      {link.flagType || link.flagText ? (
        <Flag type={link.flagType} text={link.flagText} />
      ) : null}
    </div>
  );
};

QuicklinksLink.displayName = 'QuicklinksLink';

QuicklinksLink.propTypes = {
  link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ de: PropTypes.string, en: PropTypes.string }),
    ]).isRequired,
    flagType: PropTypes.string,
    flagText: PropTypes.string,
  }).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(withTracking(trackings)(QuicklinksLink));
